export type SkeletonProps = {
  className: string
  square?: boolean
}

export const Skeleton: React.FC<SkeletonProps> = ({ className, square, ...rest }) => {
  return <div {...rest} className={className + ` ${square ? 'ui-rounded-none' : 'ui-rounded-full'}  ui-bg-gray-200 ui-animate-pulse`}></div>
}
